import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { CloseRounded, PriorityHighRounded } from '@mui/icons-material';
export const GSMAdditionalInfoIcon = memo(function GSMAdditionalInfoIcon(props) {
    const { error, warning } = props;
    return (_jsxs(_Fragment, { children: [error && (_jsx(CloseRounded, { color: "error", sx: {
                    position: 'absolute',
                    fontSize: '0.4em',
                    left: -2,
                } })), warning && (_jsx(PriorityHighRounded, { color: "warning", sx: {
                    position: 'absolute',
                    fontSize: '0.4em',
                } }))] }));
});
